import { parseCookies } from "nookies";
import axios from "../fetch/axiosInstance";
import { AWS_PRE_SIGNED_URL } from "../fetch/apiConfig";

const RTC_UPLOAD_BASE_URL = "https://rtcweb.insahr.co.kr";

const getAuthHeader = () => {
  const token =
    axios.defaults.headers.common["token"] || parseCookies().token || "";

  if (!token) {
    throw new Error("인증 토큰이 없습니다.");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

export const getPreSignedUploadUrl = async (type, fileName) => {
  const res = await axios.post(
    `${AWS_PRE_SIGNED_URL}?type=${type}`,
    { fileName },
    {
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
    },
  );

  return res.data.data;
};

export const uploadFileToS3 = async ({ file, fileName, type }) => {
  const { preSignedUrl, uploadUrl } = await getPreSignedUploadUrl(
    type,
    fileName,
  );

  const response = await fetch(preSignedUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type || "application/octet-stream",
    },
    body: file,
  });

  if (!response.ok) {
    throw new Error("S3 업로드에 실패했습니다.");
  }

  return uploadUrl;
};

const uploadRecordFileToRtc = async ({ file, fileName, peerId, roomId }) => {
  const formData = new FormData();

  formData.append("videoBlob", file, fileName);
  formData.append("siteName", `${process.env.NEXT_PUBLIC_SITE_ID}`);
  formData.append("peerId", peerId);
  formData.append("roomId", roomId);

  const response = await axios.post(
    `${RTC_UPLOAD_BASE_URL}/upload/record`,
    formData,
  );

  return response.data.message;
};

const uploadIdCardToRtc = async ({ dataUrl, fileName, groupIdx }) => {
  const response = await axios.post(`${RTC_UPLOAD_BASE_URL}/upload/snapShot`, {
    siteName: `${process.env.NEXT_PUBLIC_SITE_ID}`,
    groupIdx,
    idCardName: fileName,
    idCardFile: dataUrl,
  });

  return response.data.save_url;
};

export const uploadRecordFileWithFallback = async ({
  file,
  fileName,
  peerId,
  roomId,
}) => {
  try {
    return await uploadFileToS3({
      file,
      fileName,
      type: "RECORD",
    });
  } catch (error) {
    console.warn("S3 record upload failed, fallback to RTC upload", error);

    return uploadRecordFileToRtc({
      file,
      fileName,
      peerId,
      roomId,
    });
  }
};

export const uploadIdCardWithFallback = async ({
  file,
  fileName,
  dataUrl,
  groupIdx,
}) => {
  try {
    return await uploadFileToS3({
      file,
      fileName,
      type: "ID",
    });
  } catch (error) {
    console.warn("S3 ID card upload failed, fallback to RTC upload", error);

    return uploadIdCardToRtc({
      dataUrl,
      fileName,
      groupIdx,
    });
  }
};
